import React, { useCallback, useEffect, useState } from 'react'
import DateFnsUtils from '@date-io/date-fns'
import ptBRLocale from 'date-fns/locale/pt-BR'

import Grid from '@material-ui/core/Grid'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'

import { DatePicker } from './DatePicker'

import { Props } from './types'

import { utcToZonedTime } from 'date-fns-tz'


export const DateRangePicker: React.FC<Props> = ({
  onChange,
  labelStartAt,
  labelEndAt,
  values,
}) => {
  const handleOnChange = useCallback(
    (field: string, value: Date | null) => {
      onChange({
        ...values,
        [field]: value
          ? utcToZonedTime(new Date(value), 'America/Sao_Paulo')
          : null,
      })
    },
    [values],
  )

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
          <DatePicker
            label={labelStartAt}
            value={values.startAt}
            onChange={(date) => handleOnChange('startAt', date)}
            {...(values.endAt ? { maxDate: values.endAt } : {})}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
          <DatePicker
            label={labelEndAt}
            value={values.endAt}
            minDate={values.startAt}
            onChange={(date) => handleOnChange('endAt', date)}
          />
        </Grid>
      </Grid>
    </MuiPickersUtilsProvider>
  )
}

DateRangePicker.defaultProps = {
  labelStartAt: 'Início',
  labelEndAt: 'Fim',
}
